// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
._nft_card_case {
  position: absolute;
  top: -10%; /* Slightly above the card */
  left: -10%; /* Slightly left of the card */
  width: 120%; /* Larger than the card */
  z-index: 5; /* In front of the card content */
  pointer-events: none; /* Ensures it doesn't block interactions */
}

._nft_case_image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures it covers the area properly */
}

._nft_card {
  width: 210px;
  height: 230px;
  border: 1px solid #707070;
  background: #090909;
  border-radius: 6px;
  position: relative;
}
@media (max-width: 576px) {
  ._nft_card {
    width: 100%;
  }
}
._nft_card ._nft_hover {
  position: absolute;
  display: none;
  right: 8px;
  top: 10px;
  padding: 0;
  z-index: 1;
  cursor: pointer;
}
._nft_card ._nft_card_menu {
  background: #fff;
  width: fit-content;
  position: absolute;
  z-index: 1;
  right: 8px;
  top: 40px;
  border-radius: 6px;
}
._nft_card ._nft_card_menu p {
  color: #000;
  padding: 5px;
  font-size: 14px;
  cursor: pointer;
}
._nft_card:hover ._nft_hover {
  display: block;
}
._nft_card ._network {
  position: absolute;
  width: 24px;
  left: 8px;
  top: 10px;
  z-index: 1;
  cursor: pointer;
}
._nft_card ._record_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: default;
}
._nft_card ._record_container ._record {
  width: 137px;
  height: 137px;
}
._nft_card ._record_container ._record_level {
  position: absolute;
  bottom: 8px;
}
._nft_card ._record_container ._record_level ._record_x {
  width: 48px;
}
._nft_card ._record_container ._record_level ._record_x:not(:first-child) {
  margin-left: -25px;
}
._nft_card ._nft_data_box {
  padding: 0 6px;
  justify-content: space-between;
}
._nft_card ._nft_data_box .nft_img {
  width: 45px;
  height: 45px;
  border-radius: 3px;
  object-fit: cover;
}
._nft_card ._nft_data_box ._nft_title {
  border-radius: 3px;
  height: 45px;
  width: 145px;
  background: #171515;
  display: flex;
  justify-content: center;
}
._nft_card ._nft_data_box ._nft_title p {
  padding-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/NftCard/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA3BA;EACI,kBAAA;EACA,SAAA,EAAA,4BAAA;EACA,UAAA,EAAA,8BAAA;EACA,WAAA,EAAA,yBAAA;EACA,UAAA,EAAA,iCAAA;EACA,oBAAA,EAAA,0CAAA;AA6BJ;;AA1BE;EACE,WAAA;EACA,YAAA;EACA,iBAAA,EAAA,wCAAA;AA6BJ;;AAzBA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA4BJ;ADdE;ECpBF;IASQ,WAAA;EA6BN;AACF;AA3BI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AA6BR;AA1BI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AA4BR;AA1BQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA4BZ;AAvBQ;EACI,cAAA;AAyBZ;AArBI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAuBR;AApBI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAsBR;AApBQ;EACI,YAAA;EACA,aAAA;AAsBZ;AAnBQ;EACI,kBAAA;EACA,WAAA;AAqBZ;AAnBY;EACI,WAAA;AAqBhB;AAnBgB;EACI,kBAAA;AAqBpB;AAdI;EACI,cAAA;EACA,8BAAA;AAgBR;AAdQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAgBZ;AAbQ;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAeZ;AAbY;EACI,iBAAA;AAehB","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"../../styles/mixins\";\n._nft_card_case {\n    position: absolute;\n    top: -10%;    /* Slightly above the card */\n    left: -10%;   /* Slightly left of the card */\n    width: 120%;  /* Larger than the card */\n    z-index: 5;   /* In front of the card content */\n    pointer-events: none; /* Ensures it doesn't block interactions */\n  }\n  \n  ._nft_case_image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; /* Ensures it covers the area properly */\n  }\n  \n\n._nft_card {\n    width: 210px;\n    height: 230px;\n    border: 1px solid #707070;\n    background: #090909;\n    border-radius: 6px;\n    position: relative;\n\n    @include sm {\n        width: 100%;\n    }\n\n    ._nft_hover {\n        position: absolute;\n        display: none;\n        right: 8px;\n        top: 10px;\n        padding: 0;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    ._nft_card_menu {\n        background: #fff;\n        width: fit-content;\n        position: absolute;\n        z-index: 1;\n        right: 8px;\n        top: 40px;\n        border-radius: 6px;\n\n        p {\n            color: #000;\n            padding: 5px;\n            font-size: 14px;\n            cursor: pointer;\n        }\n    }\n\n    &:hover {\n        ._nft_hover {\n            display: block\n        }\n    }\n\n    ._network {\n        position: absolute;\n        width: 24px;\n        left: 8px;\n        top: 10px;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    ._record_container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        position: relative;\n        cursor: default;\n\n        ._record {\n            width: 137px;\n            height: 137px;\n        }\n\n        ._record_level {\n            position: absolute;\n            bottom: 8px;\n\n            ._record_x {\n                width: 48px;\n\n                &:not(:first-child) {\n                    margin-left: -25px;\n                }\n\n            }\n        }\n    }\n\n    ._nft_data_box {\n        padding: 0 6px;\n        justify-content: space-between;\n\n        .nft_img {\n            width: 45px;\n            height: 45px;\n            border-radius: 3px;\n            object-fit: cover;\n        }\n\n        ._nft_title {\n            border-radius: 3px;\n            height: 45px;\n            width: 145px;\n            background: #171515;\n            display: flex;\n            justify-content: center;\n\n            p {\n                padding-left: 6px\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
